export interface DeviceStep {
  image: string;
  alt: string;
  step: number;
  text: string;
}

export const DEVICE_INSTRUCTIONS: DeviceStep[] = [
  {
    image: '/assets/devices/steps/device_step1.png',
    alt: 'Reset Card',
    step: 1,
    text: 'common:add_device_info.add_device_steps.step1',
  },
  {
    image: '/assets/devices/steps/device_step2.png',
    alt: 'Back Sticker (Gemini, Controller)',
    step: 2,
    text: 'common:add_device_info.add_device_steps.step2',
  },
  {
    image: '/assets/devices/steps/device_step3.png',
    alt: 'Side Sticker (CORE and PRO)',
    step: 3,
    text: 'common:add_device_info.add_device_steps.step3',
  },
];
